import { DateTime } from "@/Common/Helpers/DateTime";
import { TimeSpan } from "@/Common/Models/TimeSpan";

interface ITimerProps {

    model: TimerComponentModel;

    className?: string;
    style?: React.CSSProperties

    format?: string;

    saveCallback?: (model: TimerComponentModel, value: TimeSpan) => void;
    saveIntervalSeconds?: number;
}

class TimerComponentModel {
    constructor(patientContactId: string, encounterId: string, initialValue: TimeSpan = null, label: string = null) {
        this.initialValue = initialValue == null ? new TimeSpan() : initialValue;
        this.patientContactId = patientContactId;
        this.encounterId = encounterId;
        this.label = label;
    }

    public initialValue: TimeSpan;
    public initialValueResetId: string;

    public patientContactId: string;
    public encounterId: string;
    public label: string;
    public isCounting: boolean;
}

class TimerComponentState {
    public value: TimeSpan;
}

class TimerComponent extends React.Component<ITimerProps, TimerComponentState> {
    private intervalId: number;
    private lastSaveReference: Date = DateTime.nowDeprecated();

    constructor(props: ITimerProps) {
        super(props);

        const initialState = new TimerComponentState();
        initialState.value = this.props.model.initialValue;
        this.state = initialState;
    }

    /**
     * Behavior is not so simple to changed here and will be addressed after react 18 upgrade is complete.
     */
    public UNSAFE_componentWillReceiveProps(nextProps: ITimerProps): void {
        let self = this;

        if (nextProps.model == null || nextProps.model.isCounting == false) {
            clearInterval(this.intervalId);
            this.Save(true);
        }
        else {
            if (this.props.model == null || this.props.model.initialValueResetId != nextProps.model.initialValueResetId) {
                self.Save(true); // Save the old value
                this.mutateState(
                    s => s.value = nextProps.model.initialValue,
                    () => {
                        self.Save(true); // return the New TimeSpan Reference for slave Timers
                    }
                );
            }

            // Enable CountUp function
            // @ts-ignore: Ignore error
            if (nextProps.model != null && nextProps.model.isCounting != false) { // if "isCounting" is null it must init count. Dont simplify the condition
                this.initCount();
            }
        }
    }

    public componentDidMount(): void {
        this.Save(true);
        if (this.props.model != null && this.props.model.isCounting != false) // if "isCounting" is null it must init count. Dont simplify the condition
            this.initCount(); // Start timer
    }

    public initCount(): void {
        let self = this;

        if (this.intervalId == null)
            this.intervalId = window.setInterval(() => self.countUp(), 1000); // Unpause timer
    }

    public componentWillUnmount(): void {
        clearInterval(this.intervalId);
        this.Save(true);
    }

    public render(): JSX.Element {
        let format = IsNullOrWhiteSpace(this.props.format) ? "HH:mm:ss" : this.props.format;
        let formattedTime = this.state.value.toString(format);

        return (
            <div className={this.props.className} style={this.props.style}>
                <span>{formattedTime}</span>
            </div>
        );
    }

    private mutateState(mutation: (s: TimerComponentState) => void, then: () => void = null): void {
        var s = new TimerComponentState();
        mutation(s);
        this.setState(s, then);
    }

    private countUp(): void {
        let self = this;
        this.mutateState(
            s => {
                self.state.value.AddSeconds(1); // Do not lose the reference of the TimeSpan object we a new(), SlaveComponent are bound to it by Ref
                s.value = self.state.value;
            },
            () => self.Save()
        );
    }

    private Save(force: boolean = false): void {
        let self = this;
        let saveInterval = this.props.saveIntervalSeconds == null ? 10000 : this.props.saveIntervalSeconds * 1000;

        if (self.props.saveCallback != null && (force == true || (DateTime.nowDeprecated().getTime() - this.lastSaveReference.getTime()) > saveInterval)) { // 10 secondes
            this.lastSaveReference = DateTime.nowDeprecated();
            self.props.saveCallback(self.props.model, self.state.value);
        }
    }
}

export { TimerComponent, TimerComponentModel };
